import { render, staticRenderFns } from "./BankEdit.vue?vue&type=template&id=68bbcc4f&"
import script from "./BankEdit.js?vue&type=script&lang=js&"
export * from "./BankEdit.js?vue&type=script&lang=js&"
import style0 from "./BankEdit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports